import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography/Typography";
import { useTranslation, Trans } from "react-i18next";
import "@common/Login/css/Login.scss";
import { URLS } from "@constants";
import { ForgotEmailForm } from "@features/ForgotEmail/ForgotEmailForm";
import { ForgotEmailSuccess } from "@features/ForgotEmail/ForgotEmailSuccess";
import { forgotEmailStep } from "@features/ForgotEmail/interface/IForgotEmail";
import { useForgotEmail } from "@features/ForgotEmail/hook/useForgotEmail";
import { phoneRegex } from "@utils/formControl";
import { fixUrlLanguage } from "@utils/changeLanguage";

export const ForgotEmailPage = () => {
    const {
        checkVerificationCode,
        checkPhoneNumber,
        recoverEmail,
        actualStep,
        goToInitialStep,
        postVerificationCodeState,
        postPhoneNumberState,
        isValidOtp,
    } = useForgotEmail();
    const { t } = useTranslation("forgotEmail");

    const isInitialStep = actualStep === forgotEmailStep.initial;
    const isVerificationCodeStep = actualStep === forgotEmailStep.verificationCode;
    const isSuccessStep = actualStep === forgotEmailStep.success;
    const isEmailNotVerifiedStep = actualStep === forgotEmailStep.emailNotVerified;

    return (
        <div className="container-boxed login__container">
            <Typography align="center" className="container-boxed__title" color="secondary" variant="h1">
                {t("forgotEmail")}
            </Typography>
            <Card className="login__card" elevation={2}>
                <CardContent>
                    <Grid alignItems="center" container justify="center" spacing={2}>
                        <Grid item>
                            <div className="login__helper">
                                <Typography align="center" color="secondary" variant="body1">
                                    {isInitialStep && <Trans i18nKey="forgotEmailInit" ns="forgotEmail" />}
                                    {isVerificationCodeStep && t("verificationCodeTooltip")}
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            {isInitialStep && (
                                <ForgotEmailForm
                                    callState={postPhoneNumberState}
                                    handleFormSubmit={checkPhoneNumber}
                                    label={t("mobileNumber")}
                                    name="mobileNumber"
                                    type="tel"
                                    validate={phoneRegex}
                                    isValidOtp={true}
                                />
                            )}
                            {isVerificationCodeStep && (
                                <ForgotEmailForm
                                    callState={postVerificationCodeState}
                                    goToInitialStep={goToInitialStep}
                                    handleFormSubmit={checkVerificationCode}
                                    label={t("verificationCode")}
                                    name="verificationCode"
                                    type="text"
                                    isValidOtp={isValidOtp}
                                />
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            {isSuccessStep && <ForgotEmailSuccess email={recoverEmail} isVerified />}
                            {isEmailNotVerifiedStep && <ForgotEmailSuccess email={recoverEmail} isVerified={false} />}
                        </Grid>
                        <Grid className="login__links" item>
                            <Link href={fixUrlLanguage(URLS.HOME_PAGE_URL_EN)}>
                                <Typography align="center" color="primary">
                                    {t("backLogin")}
                                </Typography>
                            </Link>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </div>
    );
};
